// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUi from 'element-ui'
import router from './router';
import store from './store';
import axios from 'axios';
import myTable from './components/myTable';
import smTable from './components/smTable';
import echarts from 'echarts';
import './assets/icon/iconfont.css';
import './assets/icon2/iconfont.css';
import './assets/font/iconfont.css';
import util from '@/util/util';
import { isLmMobileUserAgent, redirectToLmMobileAigcCreate } from '@/views/largeModel/lmMobileNavigate';
import { completeWxLogin } from '@/util/loginAuth';
import { isWxLoginMessage } from '@/util/wxLoginBridge';
import { isLegacyConsoleAigcHomeRoute, redirectToAigcFrontHome } from '@/util/aigcFrontUrl';
import { isLegacyConsoleAiIndexRoute, redirectToLlmFrontModels } from '@/util/llmFrontUrl';
import { Message } from 'element-ui';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import QRcode from './components/QRcode';

Vue.component('my-table', myTable);
Vue.component('sm-table', smTable);
Vue.use(ElementUi);
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(QRcode)
Vue.config.productionTip = false;

let authExpiredRedirectScheduled = false;

function isLmConsoleMobileUserAgent() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

function isTokenExpiredPayload(payload) {
    const p = payload && typeof payload === 'object' ? payload : {};
    const status = p.status;
    if (status === -2) return true;
    if (status !== 0) return false;
    const msg = String(p.message || p.msg || p.error_msg || '').toLowerCase();
    return msg.indexOf('token') !== -1 && (msg.indexOf('过期') !== -1 || msg.indexOf('expired') !== -1);
}

function redirectOnLoginExpired() {
    if (authExpiredRedirectScheduled) {
        return;
    }
    authExpiredRedirectScheduled = true;
    store.commit('resetUserInfo');
    util.removeAllInfo();
    const hash = window.location.hash || '';
    const isLargeModel = hash.indexOf('large-model') !== -1 || hash.indexOf('aigc') !== -1;
    if (isLargeModel) {
        if (isLmConsoleMobileUserAgent()) {
            const m = String(process.env.TEMPLATE_M_URL || '')
                .trim()
                .replace(/\/+$/, '');
            if (m) {
                window.location.href = `${m}/#/aigc/login`;
                return;
            }
        }
        window.location.hash = '#/login';
    } else {
        window.location.href = process.env.TEMPLATE_URL + '/login/';
    }
}

axios.interceptors.request.use(config => {
    if (util.getCookie('front_token')) {
        config.headers.Authorization = util.getCookie('front_token');
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    const res = response.data;
    if (isTokenExpiredPayload(res)) {
        redirectOnLoginExpired();
        return Promise.reject(new Error('登录过期'));
    }
    return response;
}, error => {
    const resp = error && error.response;
    if (resp) {
        const data = resp.data;
        const bodyExpired = isTokenExpiredPayload(data);
        if (resp.status === 401 || bodyExpired) {
            redirectOnLoginExpired();
            return Promise.reject(new Error('登录过期'));
        }
    }
    return Promise.reject(error);
});

//修改axios原型链
Vue.prototype.Axios = axios;
// 打包接口地址
Vue.prototype.Axios.defaults.baseURL = process.env.BASE_URL;
Vue.prototype.ImageUrl = process.env.BASE_URL;
// 环境
Vue.prototype.Env = process.env.NODE_ENV;
// 跳转前台地址
Vue.prototype.FrontUrl = process.env.TEMPLATE_URL;
Vue.prototype.Echarts = echarts;
// 跳转移动端地址
Vue.prototype.MobileUrl = process.env.TEMPLATE_M_URL;
// 延迟多少秒后跳转页面
Vue.prototype.WatingTime = 1000;

router.beforeEach((to, from, next) => {
    if (isLegacyConsoleAigcHomeRoute(to)) {
        redirectToAigcFrontHome(true);
        return;
    }
    if (isLegacyConsoleAiIndexRoute(to)) {
        redirectToLlmFrontModels(true);
        return;
    }
    if (to.matched.length) {
        const hasToken = util.getCookie('front_token');
        const isLoginPage = to.path === '/login' || to.name === 'login';
        const isWxAuthPage = to.name === 'wx_callback' || to.name === 'user_wx_callback' || to.name === 'wx_bind';
        const isLargeModelRoute = to.path.indexOf('/aigc') === 0 || to.path.indexOf('/large-model') === 0;
        const isAigcHome = to.name === 'lm_home' || to.path === '/aigc' || to.path.indexOf('/aigc/home') === 0;
        const isPublicRoute = to.name === 'lm_real_human_liveness' || isWxAuthPage;
        if (isLoginPage || isWxAuthPage) {
            if (hasToken) {
                next({ name: 'lm_image_create' });
            } else {
                next();
            }
            return;
        }
        if (isPublicRoute) {
            next();
            return;
        }
        if (hasToken) {
            if (to.name === 'lm_image_create' && isLmMobileUserAgent()) {
                if (redirectToLmMobileAigcCreate(process.env.TEMPLATE_M_URL)) return;
            }
            next();
        } else {
            store.commit('resetUserInfo');
            util.removeAllInfo();
            if (isAigcHome) {
                next();
            } else if (isLargeModelRoute) {
                next({ path: '/login', query: { redirect: to.fullPath } });
            } else {
                window.location.href = process.env.TEMPLATE_URL + '/login/';
            }
        }
    } else {
        next({ path: '/404/' });
    }
})

function handleWxLoginMessage(e) {
    if (!isWxLoginMessage(e.data)) return;
    const code = String(e.data.code);
    const state = e.data.state ? String(e.data.state) : '';
    completeWxLogin(
        {
            axios,
            store,
            router,
            route: router.currentRoute,
            onError(msg) {
                Message.error(msg);
            },
        },
        code,
        state
    ).catch(() => {});
}

window.addEventListener('message', handleWxLoginMessage);

router.afterEach((to) => {
    try {
        if (to && (to.path === '/login' || to.name === 'login')) {
            authExpiredRedirectScheduled = false;
        }
        const legacyBase = 'BaiCloud';
        const aigcBase = '白云AIGC短剧创作平台';
        const p = (to && to.path) || '';
        const isAigcLogin = p === '/login' || (to && to.name === 'login');
        const isAigc = isAigcLogin || p.indexOf('/aigc') === 0 || p.indexOf('/large-model') === 0;
        const t = to && to.meta && to.meta.title ? String(to.meta.title) : '';
        document.title = isAigc ? (t ? `${t} - ${aigcBase}` : aigcBase) : legacyBase;
    } catch (e) {}
});
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js